import { Box, styled } from '@mui/material';

export const ConstructorBlock = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '30px',
  maxWidth: '1160px',
  margin: '0 auto',
  gridTemplateColumns: 'calc((100% - ((100% - 60px)/3 + 30px))) 1fr',
  [theme.breakpoints.down(992)]: {
    gridTemplateColumns: '100%',
  },
}));

export const ConstructorHeader = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: '0',
  zIndex: '5',
  background: 'white',
}));
